















































import { Vue, Component } from "vue-property-decorator";
import starImg from "@/assets/star.png";
import { getCaseList } from "@/http/case";
@Component
export default class CaseList extends Vue {
  linkDetail(row: any) {
    this.$router.push(`case/detail/${row.id}`);
  }
  list: Array<any> = [];
  // 当前点赞图片
  getImageUrl() {
    return starImg;
  }
  // 封面图片
  getCoverImage(item:any) {
    return window.StaticUrl + "/" + item.imgUrl;
  }
  async getList() {
    try {
      const res = await getCaseList();
      this.list = res;
    } catch (error) {
      this.list = [];
    }
  }
  mounted() {
    this.getList();
    if (sessionStorage.getItem("loaded")) {
      location.reload();
      sessionStorage.removeItem("loaded")
    }
  }
}
